<template>
    <b-container fluid>
        <b-overlay :show="customLoading" rounded="sm">
            <b-row>
                <b-col lg="6" sm="12" md="12" xl="12">
                    <b-button type="button" variant="primary" class="mr-2" @click="printID">{{ $t('globalTrans.print') }}</b-button>
                </b-col>
            </b-row>
            <b-row id="printMe">
                <b-col lg="6" sm="12" md="12" xl="12">
                    <div class="certificate-bg">
                        <div class="top-section">
                            <div class="top-left">
                                <span> নম্বর- {{ addZeroPad(item.application.release_id) }}/{{ getBatch(item.batch.batch_id) }} তম/ {{ getFiscalYear(item.batch.fiscal_year_id) }} </span>
                            </div>
                            <div class="top-middle">
                                <img :src="baseUrl + 'uploads/certificate/desh.jpg'"/>
                                <h5> গণপ্রজাতন্ত্রী বাংলাদেশ সরকার </h5>
                                <h4> সমাজকল্যাণ মন্ত্রণালয় </h4>
                                <h2> বাংলাদেশ জাতীয় সমাজকল্যাণ পরিষদ, ঢাকা </h2>
                                <h1> সনদপত্র </h1>
                            </div>
                            <div class="top-right">
                                <img width="100px" :src="baseUrl + 'download-attachment?file=uploads/trainee/profile/'+ item.application.trainee.photo" all="trainee photo"/>
                            </div>
                        </div>
                        <div class="middle-section">
                            <p class="first-line">
                                <span> প্রত্যায়ন করা যাচ্ছে যে, </span> <b>{{ item.application.trainee.name_bn }}, {{ (item.application.trainee.designation_id ? getDesignation(item.application.trainee.designation_id) : item.application.trainee.other_designation) }}, {{ getOrg(item.application.trainee.reg_org_id) }} </b>
                            </p>
                            <p class="second-line"> <b> {{ addressDetails(item.application.trainee) }}  </b> <strong></strong> </p>
                            <p class="third-line">
                                <b>{{ EngBangNum(item.batch.batch_start_date) }}</b> হতে <b>{{ EngBangNum(item.batch.batch_end_date) }}</b> তারিখ পর্যন্ত অনুষ্ঠিত “ {{ getTraining(item.application.training_title_id) }} ” শীর্ষক {{ getDiffDate(item.batch.batch_start_date,item.batch.batch_end_date) }} দিন ব্যাপি প্রশিক্ষণের <b> {{ getBatch(item.batch.batch_id) }} </b> র্কোস সফলভাবে সম্পন্ন করেছেন।
                            </p>
                        </div>
                        <div class="bottom-section">
                            <div class="bottom-left">
                              <div v-if="item.batch.certificate_signature">
                                <img v-if="item.batch.certificate_signature.course_coordinate" width="100" height="50" :src="baseUrl + 'download-attachment?file=uploads/certificate/release/' + item.batch.certificate_signature.course_coordinate"/>
                              </div>
                              <p v-else class="pt-5"></p>
                              <p><b> কোর্স সমন্বয়ক </b></p>
                                <p> বাংলাদেশ জাতীয় সামাজকল্যাণমূলক পরিষদ </p>
                            </div>
                            <div class="bottom-left">
                             <div v-if="item.batch.certificate_signature">
                               <img v-if="item.batch.certificate_signature.course_director" width="100" height="50" :src="baseUrl + 'download-attachment?file=uploads/certificate/release/' + item.batch.certificate_signature.course_director"/>
                             </div>
                              <p v-else class="pt-5"></p>
                                <p><b> কোর্স পরিচালক </b></p>
                                <p> বাংলাদেশ জাতীয় সামাজকল্যাণমূলক পরিষদ </p>
                            </div>
                        </div>
                    </div>
                </b-col>
            </b-row>
        </b-overlay>
    </b-container>
</template>
<script>
import { trainingElearningServiceBaseUrl } from '@/config/api_config'
import printHtmlBlock from 'print-html-block'

    export default {
        props: ['item'],
        components: {
        },
        data () {
            return {
                formData: {
                    fiscal_year_id: 0,
                    circular_publication_id: 0,
                    training_title_id: 0,
                    batch_id: 0,
                    traineeList: []
                },
                baseUrl: trainingElearningServiceBaseUrl,
                alreadyExist: [],
                customLoading: false
            }
        },
        computed: {
            currentLocale () {
                return this.$i18n.locale
            }
        },
        watch: {
        },
        created () {
        },
        methods: {
            printID () {
                const selector = '#printMe'
                const options = {
                    importStyle: true
                }
                printHtmlBlock(selector, options)
            },
            getFiscalYear (fiscalYearId) {
                const fiscalObj = this.$store.state.commonObj.fiscalYearList.find(item => item.value === fiscalYearId)
                return fiscalObj.text_bn
            },
            getTraining (trainingId) {
                const trainingObj = this.$store.state.TrainingElearning.commonObj.trainingNameList.find(item => item.value === trainingId)
                return trainingObj.text_bn
            },
            getBatch (batchId) {
                const batchObj = this.$store.state.TrainingElearning.commonObj.batchList.find(item => item.value === batchId)
                return batchObj.text_bn
            },
            addZeroPad (n) {
                var data = (n < 10) ? ('0' + n) : n
                return this.EngBangNum(data)
            },
            EngBangNum (n) {
                if (n) {
                   return n.toString().replace(/\d/g, d => '০১২৩৪৫৬৭৮৯'[d])
                }
            },
            getDesignation (designationId) {
                const designationObj = this.$store.state.TrainingElearning.commonObj.designationList.find(item => item.value === designationId)
                if (designationObj !== undefined) {
                    return designationObj.text_bn
                }
            },
            getOrg (orgId) {
                const orgObj = this.$store.state.TrainingElearning.commonObj.registeredOrgList.find(item => item.value === orgId)
                if (orgObj !== undefined) {
                    return orgObj.text_bn
                }
            },
            getDiffDate (start, end) {
                const date1 = new Date(start)
                const date2 = new Date(end)
                const diffTime = Math.abs(date2 - date1)
                const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24))
                return this.$n(diffDays)
            },
            addressDetails (data) {
                if (data.pre_area_id === 1) {
                    return this.Word(data.pre_ward_id) + this.CityCorp(data.pre_city_corporation_id) + this.District(data.pre_district_id) + this.Division(data.pre_division_id)
                }
                if (data.pre_area_id === 2) {
                    return this.Word(data.pre_ward_id) + this.Pouroshova(data.pre_paurasabha_id) + this.Upazilla(data.pre_upazila_id) + this.District(data.pre_district_id) + this.Division(data.pre_division_id)
                }
                if (data.pre_area_id === 3) {
                    return this.Word(data.pre_ward_id) + this.Union(data.pre_union_id) + this.Upazilla(data.pre_upazila_id) + this.District(data.pre_district_id) + this.Division(data.pre_division_id)
                }
            },
            Division (id) {
                if (id) {
                    if (id > 0) {
                        const data = this.$store.state.commonObj.divisionList.find(item => item.value === id)
                        return data.text_bn
                    }
                } else {
                    return ''
                }
            },
            District (id) {
                if (id) {
                    if (id > 0) {
                        const data = this.$store.state.commonObj.districtList.find(item => item.value === id)
                        return data.text_bn + ', '
                    }
                } else {
                    return ''
                }
            },
            CityCorp (id = null) {
                if (id) {
                    if (id > 0) {
                        const data = this.$store.state.commonObj.cityCorporationList.find(item => item.value === id)
                        return data.text_bn + ', '
                    }
                } else {
                    return ''
                }
            },
            Pouroshova (id = null) {
                if (id) {
                    if (id > 0) {
                        const data = this.$store.state.commonObj.pauroshobaList.find(item => item.value === id)
                        // return (this.$i18n.locale === 'bn' ? data.text_bn : data.text_en) + ', '
                        return data.text_bn + ', '
                    }
                } else {
                    return ''
                }
            },
            Upazilla (id = null) {
                if (id) {
                    if (id > 0) {
                        const data = this.$store.state.commonObj.upazilaList.find(item => item.value === id)
                        return data.text_bn + ', '
                    }
                } else {
                    return ''
                }
            },
            Union (id = null) {
                if (id) {
                    if (id > 0) {
                        const data = this.$store.state.commonObj.unionList.find(item => item.value === id)
                        return data.text_bn + ', '
                    }
                } else {
                    return ''
                }
            },
            Word (id = null) {
                if (id) {
                    if (id > 0) {
                        const data = this.$store.state.commonObj.wardList.find(item => item.value === id)
                        if (data !== undefined) {
                            return data.text_bn + ', '
                        }
                    }
                } else {
                    return ''
                }
            }
        }
    }
</script>
<style scoped>
    .certificate-bg {
        color:#000;
        background: url('../../../../../assets/images/trainning-learning/frame/jolcap.jpg');
        background-size: cover;
        background-position: center;
    }
    .top-section {
        position: relative;
    }
    .middle-section {
        padding: 10px 30px 0;
    }
    .top-middle{
        text-align: center;
    }
    .top-middle img {
        margin: 20px 0px;
    }
    .top-middle h5 {
        font-size:14px;
    }
    .top-middle h4 {
        font-size: 20px;
        font-weight: 900;
    }
    .top-middle h2 {
        font-size: 25px;
    }
    .top-middle h1 {
        font-size: 30px;
        font-weight: 900;
        color:#039a0b;
    }
    .top-right{
        display: inline-block;
        position: absolute;
        top:25px;
        right: 25px;
    }
    .top-right img {
        width: 100px;
    }
    .top-left {
        position: absolute;
        top: 20px;
        left: 25px;
    }
    .bottom-section {
        display: flex;
        width: 100%;
        text-align: center;
        padding-bottom: 20px;
    }
    .bottom-left {
        flex: 1;
        margin-bottom: 10px;
    }
    .bottom-left p {
        margin-bottom: 0;
    }
    p.first-line{
        position: relative;
    }
    p.first-line::after {
        content: "";
        position: absolute;
        border-bottom: 1px dotted #000;
        width: 80%;
        bottom: 0;
        left: 20%;
    }
    p.second-line {
        position: relative;
    }

    p.second-line::after {
        content: "";
        position: absolute;
        width: 100%;
        border-bottom: 1px dotted #000;
        bottom: 0;
        left: 0;
    }
    p.third-line b {
        border-bottom: 1px dotted #000;
        padding: 0 10px;
    }
</style>
